export const translations = {
  en: {
    // Header
    wifiPortal: "Wi-Fi Access Portal",
    gdprCompliance: "GDPR Compliance Required",
    
    // Welcome section
    welcome: "Welcome to {organization}'s Wi-Fi",
    complianceRequired: "To use this Wi-Fi service, you must read and accept our Terms of Use and Privacy Policy in accordance with the General Data Protection Regulation (GDPR).",
    
    // Terms of Use
    termsOfUse: "Terms of Use",
    termsContent: "By accessing this Wi-Fi network, you agree to:",
    termsPoints: [
      "Use the service responsibly and legally.",
      "Avoid any activity that may harm the network or other users.",
      "Accept that access may be monitored for security and compliance purposes."
    ],
    
    // Privacy Notice
    privacyNotice: "Privacy Notice",
    dataCollection: "We collect and process the following data:",
    dataPoints: [
      "Device MAC address",
      "Connection timestamps", 
      "Location of access point",
      "Browser and device type"
    ],
    
    // Purpose
    purposeTitle: "Purpose of data collection:",
    purposePoints: [
      "Network security and fraud prevention",
      "Legal compliance",
      "Usage statistics and service improvement"
    ],
    
    // Data retention
    dataRetention: "Data retention: Your data will be stored for a maximum of {months} months and then securely deleted.",
    
    // User rights
    userRights: "Your rights:",
    rightsPoints: [
      "Access, correction, deletion of your data",
      "Withdrawal of consent at any time",
      "Contact our Data Protection Officer at: {email}"
    ],
    
    // Consent
    consentTitle: "Consent",
    consentText: "Please confirm your acceptance to proceed:",
    consentCheckbox: "I have read and accept the Terms of Use and Privacy Policy. I consent to the processing of my personal data as described above.",
    
    // Signature
    signatureTitle: "Digital Signature",
    signaturePlaceholder: "Type your full name here as digital signature",
    signatureRequired: "Digital signature is required for legal compliance",
    
    // Buttons
    connectToWifi: "Continue to Sateva Hotspot's Wi-Fi",
    language: "Language",
    decline: "Decline",
    
    // Validation
    mustAcceptTerms: "You must accept the terms and conditions to proceed",
    mustProvideSignature: "Digital signature is required",
    
    // Footer
    poweredBy: "Powered by GDPR-Compliant Portal System",
    lastUpdated: "Last updated: {date}"
  },
  
  fr: {
    // Header  
    wifiPortal: "Portail d'Accès Wi-Fi",
    gdprCompliance: "Conformité RGPD Requise",
    
    // Welcome section
    welcome: "Bienvenue sur le Wi-Fi de {organization}",
    complianceRequired: "Pour utiliser ce service Wi-Fi, vous devez lire et accepter nos Conditions d'Utilisation et notre Politique de Confidentialité conformément au Règlement Général sur la Protection des Données (RGPD).",
    
    // Terms of Use
    termsOfUse: "Conditions d'Utilisation",
    termsContent: "En accédant à ce réseau Wi-Fi, vous acceptez de :",
    termsPoints: [
      "Utiliser le service de manière responsable et légale.",
      "Éviter toute activité pouvant nuire au réseau ou aux autres utilisateurs.",
      "Accepter que l'accès puisse être surveillé à des fins de sécurité et de conformité."
    ],
    
    // Privacy Notice
    privacyNotice: "Avis de Confidentialité",
    dataCollection: "Nous collectons et traitons les données suivantes :",
    dataPoints: [
      "Adresse MAC de l'appareil",
      "Horodatage des connexions",
      "Localisation du point d'accès", 
      "Type de navigateur et d'appareil"
    ],
    
    // Purpose
    purposeTitle: "Finalité de la collecte de données :",
    purposePoints: [
      "Sécurité du réseau et prévention de la fraude",
      "Conformité légale",
      "Statistiques d'utilisation et amélioration du service"
    ],
    
    // Data retention
    dataRetention: "Conservation des données : Vos données seront conservées pendant un maximum de {months} mois puis supprimées de manière sécurisée.",
    
    // User rights
    userRights: "Vos droits :",
    rightsPoints: [
      "Accès, correction, suppression de vos données",
      "Retrait du consentement à tout moment",
      "Contacter notre Délégué à la Protection des Données : {email}"
    ],
    
    // Consent
    consentTitle: "Consentement",
    consentText: "Veuillez confirmer votre acceptation pour continuer :",
    consentCheckbox: "J'ai lu et j'accepte les Conditions d'Utilisation et la Politique de Confidentialité. Je consens au traitement de mes données personnelles comme décrit ci-dessus.",
    
    // Signature
    signatureTitle: "Signature Numérique",
    signaturePlaceholder: "Tapez votre nom complet ici comme signature numérique",
    signatureRequired: "La signature numérique est requise pour la conformité légale",
    
    // Buttons
    connectToWifi: "Continuer vers le Wi-Fi de Sateva Hotspot",
    language: "Langue",
    decline: "Refuser",
    
    // Validation
    mustAcceptTerms: "Vous devez accepter les conditions générales pour continuer",
    mustProvideSignature: "La signature numérique est requise",
    
    // Footer
    poweredBy: "Propulsé par le Système de Portail Conforme RGPD",
    lastUpdated: "Dernière mise à jour : {date}"
  },
  
  es: {
    // Header
    wifiPortal: "Portal de Acceso Wi-Fi",
    gdprCompliance: "Cumplimiento RGPD Requerido",
    
    // Welcome section
    welcome: "Bienvenido al Wi-Fi de {organization}",
    complianceRequired: "Para usar este servicio Wi-Fi, debe leer y aceptar nuestros Términos de Uso y Política de Privacidad de acuerdo con el Reglamento General de Protección de Datos (RGPD).",
    
    // Terms of Use
    termsOfUse: "Términos de Uso",
    termsContent: "Al acceder a esta red Wi-Fi, acepta:",
    termsPoints: [
      "Usar el servicio de manera responsable y legal.",
      "Evitar cualquier actividad que pueda dañar la red u otros usuarios.",
      "Aceptar que el acceso puede ser monitoreado por motivos de seguridad y cumplimiento."
    ],
    
    // Privacy Notice
    privacyNotice: "Aviso de Privacidad",
    dataCollection: "Recopilamos y procesamos los siguientes datos:",
    dataPoints: [
      "Dirección MAC del dispositivo",
      "Marcas de tiempo de conexión",
      "Ubicación del punto de acceso",
      "Tipo de navegador y dispositivo"
    ],
    
    // Purpose
    purposeTitle: "Propósito de la recopilación de datos:",
    purposePoints: [
      "Seguridad de red y prevención de fraude",
      "Cumplimiento legal",
      "Estadísticas de uso y mejora del servicio"
    ],
    
    // Data retention
    dataRetention: "Retención de datos: Sus datos se almacenarán por un máximo de {months} meses y luego se eliminarán de forma segura.",
    
    // User rights
    userRights: "Sus derechos:",
    rightsPoints: [
      "Acceso, corrección, eliminación de sus datos",
      "Retirada del consentimiento en cualquier momento",
      "Contactar a nuestro Oficial de Protección de Datos en: {email}"
    ],
    
    // Consent
    consentTitle: "Consentimiento",
    consentText: "Por favor confirme su aceptación para proceder:",
    consentCheckbox: "He leído y acepto los Términos de Uso y la Política de Privacidad. Consiento el procesamiento de mis datos personales como se describe arriba.",
    
    // Signature
    signatureTitle: "Firma Digital",
    signaturePlaceholder: "Escriba su nombre completo aquí como firma digital",
    signatureRequired: "La firma digital es requerida para cumplimiento legal",
    
    // Buttons
    connectToWifi: "Continuar al Wi-Fi de Sateva Hotspot",
    language: "Idioma",
    decline: "Rechazar",
    
    // Validation
    mustAcceptTerms: "Debe aceptar los términos y condiciones para proceder",
    mustProvideSignature: "La firma digital es requerida",
    
    // Footer
    poweredBy: "Impulsado por Sistema de Portal Conforme RGPD",
    lastUpdated: "Última actualización: {date}"
  },
  
  de: {
    // Header
    wifiPortal: "Wi-Fi Zugangsportal",
    gdprCompliance: "DSGVO-Konformität Erforderlich",
    
    // Welcome section
    welcome: "Willkommen zum Wi-Fi von {organization}",
    complianceRequired: "Um diesen Wi-Fi-Service zu nutzen, müssen Sie unsere Nutzungsbedingungen und Datenschutzrichtlinie gemäß der Datenschutz-Grundverordnung (DSGVO) lesen und akzeptieren.",
    
    // Terms of Use
    termsOfUse: "Nutzungsbedingungen",
    termsContent: "Durch den Zugang zu diesem Wi-Fi-Netzwerk stimmen Sie zu:",
    termsPoints: [
      "Den Service verantwortlich und rechtmäßig zu nutzen.",
      "Jede Aktivität zu vermeiden, die das Netzwerk oder andere Benutzer schädigen könnte.",
      "Zu akzeptieren, dass der Zugang zu Sicherheits- und Compliance-Zwecken überwacht werden kann."
    ],
    
    // Privacy Notice
    privacyNotice: "Datenschutzerklärung",
    dataCollection: "Wir sammeln und verarbeiten folgende Daten:",
    dataPoints: [
      "Geräte-MAC-Adresse",
      "Verbindungszeiten",
      "Standort des Zugangspunkts",
      "Browser- und Gerätetyp"
    ],
    
    // Purpose
    purposeTitle: "Zweck der Datenerfassung:",
    purposePoints: [
      "Netzwerksicherheit und Betrugsprävention",
      "Rechtliche Compliance",
      "Nutzungsstatistiken und Serviceverbesserung"
    ],
    
    // Data retention
    dataRetention: "Datenspeicherung: Ihre Daten werden maximal {months} Monate gespeichert und dann sicher gelöscht.",
    
    // User rights
    userRights: "Ihre Rechte:",
    rightsPoints: [
      "Zugang, Korrektur, Löschung Ihrer Daten",
      "Widerruf der Einwilligung jederzeit",
      "Kontakt zu unserem Datenschutzbeauftragten: {email}"
    ],
    
    // Consent
    consentTitle: "Einwilligung",
    consentText: "Bitte bestätigen Sie Ihre Zustimmung um fortzufahren:",
    consentCheckbox: "Ich habe die Nutzungsbedingungen und Datenschutzrichtlinie gelesen und akzeptiere sie. Ich stimme der Verarbeitung meiner persönlichen Daten wie oben beschrieben zu.",
    
    // Signature
    signatureTitle: "Digitale Unterschrift",
    signaturePlaceholder: "Geben Sie hier Ihren vollständigen Namen als digitale Unterschrift ein",
    signatureRequired: "Digitale Unterschrift ist für rechtliche Compliance erforderlich",
    
    // Buttons
    connectToWifi: "Weiter zum Wi-Fi von Sateva Hotspot",
    language: "Sprache",
    decline: "Ablehnen",
    
    // Validation
    mustAcceptTerms: "Sie müssen die Geschäftsbedingungen akzeptieren um fortzufahren",
    mustProvideSignature: "Digitale Unterschrift ist erforderlich",
    
    // Footer
    poweredBy: "Betrieben von DSGVO-konformem Portal-System",
    lastUpdated: "Zuletzt aktualisiert: {date}"
  },
  
  it: {
    // Header
    wifiPortal: "Portale di Accesso Wi-Fi",
    gdprCompliance: "Conformità GDPR Richiesta",
    
    // Welcome section
    welcome: "Benvenuto al Wi-Fi di {organization}",
    complianceRequired: "Per utilizzare questo servizio Wi-Fi, devi leggere e accettare i nostri Termini di Utilizzo e l'Informativa sulla Privacy in conformità al Regolamento Generale sulla Protezione dei Dati (GDPR).",
    
    // Terms of Use
    termsOfUse: "Termini di Utilizzo",
    termsContent: "Accedendo a questa rete Wi-Fi, accetti di:",
    termsPoints: [
      "Utilizzare il servizio in modo responsabile e legale.",
      "Evitare qualsiasi attività che possa danneggiare la rete o altri utenti.",
      "Accettare che l'accesso possa essere monitorato per motivi di sicurezza e conformità."
    ],
    
    // Privacy Notice
    privacyNotice: "Informativa sulla Privacy",
    dataCollection: "Raccogliamo e trattiamo i seguenti dati:",
    dataPoints: [
      "Indirizzo MAC del dispositivo",
      "Timestamp di connessione",
      "Posizione del punto di accesso",
      "Tipo di browser e dispositivo"
    ],
    
    // Purpose
    purposeTitle: "Scopo della raccolta dati:",
    purposePoints: [
      "Sicurezza della rete e prevenzione frodi",
      "Conformità legale",
      "Statistiche di utilizzo e miglioramento del servizio"
    ],
    
    // Data retention
    dataRetention: "Conservazione dati: I tuoi dati saranno conservati per un massimo di {months} mesi e poi eliminati in modo sicuro.",
    
    // User rights
    userRights: "I tuoi diritti:",
    rightsPoints: [
      "Accesso, correzione, cancellazione dei tuoi dati",
      "Revoca del consenso in qualsiasi momento",
      "Contattare il nostro Responsabile della Protezione Dati: {email}"
    ],
    
    // Consent
    consentTitle: "Consenso",
    consentText: "Per favore conferma la tua accettazione per procedere:",
    consentCheckbox: "Ho letto e accetto i Termini di Utilizzo e l'Informativa sulla Privacy. Acconsento al trattamento dei miei dati personali come descritto sopra.",
    
    // Signature
    signatureTitle: "Firma Digitale",
    signaturePlaceholder: "Digita il tuo nome completo qui come firma digitale",
    signatureRequired: "La firma digitale è richiesta per conformità legale",
    
    // Buttons
    connectToWifi: "Continua al Wi-Fi di Sateva Hotspot",
    language: "Lingua",
    decline: "Rifiuta",
    
    // Validation
    mustAcceptTerms: "Devi accettare i termini e le condizioni per procedere",
    mustProvideSignature: "La firma digitale è richiesta",
    
    // Footer
    poweredBy: "Alimentato da Sistema Portale Conforme GDPR",
    lastUpdated: "Ultimo aggiornamento: {date}"
  },
  
  pt: {
    // Header
    wifiPortal: "Portal de Acesso Wi-Fi",
    gdprCompliance: "Conformidade RGPD Necessária",
    
    // Welcome section
    welcome: "Bem-vindo ao Wi-Fi da {organization}",
    complianceRequired: "Para usar este serviço Wi-Fi, você deve ler e aceitar nossos Termos de Uso e Política de Privacidade de acordo com o Regulamento Geral de Proteção de Dados (RGPD).",
    
    // Terms of Use
    termsOfUse: "Termos de Uso",
    termsContent: "Ao acessar esta rede Wi-Fi, você concorda em:",
    termsPoints: [
      "Usar o serviço de forma responsável e legal.",
      "Evitar qualquer atividade que possa prejudicar a rede ou outros usuários.",
      "Aceitar que o acesso pode ser monitorado para fins de segurança e conformidade."
    ],
    
    // Privacy Notice
    privacyNotice: "Aviso de Privacidade",
    dataCollection: "Coletamos e processamos os seguintes dados:",
    dataPoints: [
      "Endereço MAC do dispositivo",
      "Timestamps de conexão",
      "Localização do ponto de acesso",
      "Tipo de navegador e dispositivo"
    ],
    
    // Purpose
    purposeTitle: "Propósito da coleta de dados:",
    purposePoints: [
      "Segurança da rede e prevenção de fraude",
      "Conformidade legal",
      "Estatísticas de uso e melhoria do serviço"
    ],
    
    // Data retention
    dataRetention: "Retenção de dados: Seus dados serão armazenados por no máximo {months} meses e depois excluídos com segurança.",
    
    // User rights
    userRights: "Seus direitos:",
    rightsPoints: [
      "Acesso, correção, exclusão de seus dados",
      "Retirada do consentimento a qualquer momento",
      "Contatar nosso Encarregado de Proteção de Dados: {email}"
    ],
    
    // Consent
    consentTitle: "Consentimento",
    consentText: "Por favor confirme sua aceitação para prosseguir:",
    consentCheckbox: "Li e aceito os Termos de Uso e Política de Privacidade. Consinto com o processamento dos meus dados pessoais conforme descrito acima.",
    
    // Signature
    signatureTitle: "Assinatura Digital",
    signaturePlaceholder: "Digite seu nome completo aqui como assinatura digital",
    signatureRequired: "Assinatura digital é necessária para conformidade legal",
    
    // Buttons
    connectToWifi: "Continuar para o Wi-Fi da Sateva Hotspot",
    language: "Idioma",
    decline: "Recusar",
    
    // Validation
    mustAcceptTerms: "Você deve aceitar os termos e condições para prosseguir",
    mustProvideSignature: "Assinatura digital é necessária",
    
    // Footer
    poweredBy: "Alimentado por Sistema de Portal Conforme RGPD",
    lastUpdated: "Última atualização: {date}"
  },
  
  nl: {
    // Header
    wifiPortal: "Wi-Fi Toegangsportaal",
    gdprCompliance: "AVG-naleving Vereist",
    
    // Welcome section
    welcome: "Welkom bij {organization}'s Wi-Fi",
    complianceRequired: "Om deze Wi-Fi-service te gebruiken, moet u onze Gebruiksvoorwaarden en Privacybeleid lezen en accepteren in overeenstemming met de Algemene Verordening Gegevensbescherming (AVG).",
    
    // Terms of Use
    termsOfUse: "Gebruiksvoorwaarden",
    termsContent: "Door toegang te krijgen tot dit Wi-Fi-netwerk, gaat u akkoord met:",
    termsPoints: [
      "De service verantwoordelijk en legaal gebruiken.",
      "Elke activiteit vermijden die het netwerk of andere gebruikers kan schaden.",
      "Accepteren dat toegang kan worden gecontroleerd voor veiligheids- en nalevingsdoeleinden."
    ],
    
    // Privacy Notice
    privacyNotice: "Privacyverklaring",
    dataCollection: "We verzamelen en verwerken de volgende gegevens:",
    dataPoints: [
      "MAC-adres van apparaat",
      "Verbindingstijdstempels",
      "Locatie van toegangspunt",
      "Browser- en apparaattype"
    ],
    
    // Purpose
    purposeTitle: "Doel van gegevensverzameling:",
    purposePoints: [
      "Netwerkbeveiliging en fraudepreventie",
      "Juridische naleving",
      "Gebruiksstatistieken en serviceverbetering"
    ],
    
    // Data retention
    dataRetention: "Gegevensbewaring: Uw gegevens worden maximaal {months} maanden bewaard en daarna veilig verwijderd.",
    
    // User rights
    userRights: "Uw rechten:",
    rightsPoints: [
      "Toegang, correctie, verwijdering van uw gegevens",
      "Intrekking van toestemming op elk moment",
      "Contact met onze Functionaris Gegevensbescherming: {email}"
    ],
    
    // Consent
    consentTitle: "Toestemming",
    consentText: "Bevestig uw acceptatie om door te gaan:",
    consentCheckbox: "Ik heb de Gebruiksvoorwaarden en Privacyverklaring gelezen en geaccepteerd. Ik stem in met de verwerking van mijn persoonlijke gegevens zoals hierboven beschreven.",
    
    // Signature
    signatureTitle: "Digitale Handtekening",
    signaturePlaceholder: "Typ hier uw volledige naam als digitale handtekening",
    signatureRequired: "Digitale handtekening is vereist voor juridische naleving",
    
    // Buttons
    connectToWifi: "Doorgaan naar Sateva Hotspot's Wi-Fi",
    language: "Taal",
    decline: "Weigeren",
    
    // Validation
    mustAcceptTerms: "U moet de algemene voorwaarden accepteren om door te gaan",
    mustProvideSignature: "Digitale handtekening is vereist",
    
    // Footer
    poweredBy: "Aangedreven door AVG-conform Portaalsysteem",
    lastUpdated: "Laatst bijgewerkt: {date}"
  },
  
  sv: {
    // Header
    wifiPortal: "Wi-Fi Åtkomstportal",
    gdprCompliance: "GDPR-efterlevnad Krävs",
    
    // Welcome section
    welcome: "Välkommen till {organization}s Wi-Fi",
    complianceRequired: "För att använda denna Wi-Fi-tjänst måste du läsa och acceptera våra Användarvillkor och Integritetspolicy i enlighet med den allmänna dataskyddsförordningen (GDPR).",
    
    // Terms of Use
    termsOfUse: "Användarvillkor",
    termsContent: "Genom att komma åt detta Wi-Fi-nätverk accepterar du att:",
    termsPoints: [
      "Använda tjänsten ansvarsfullt och lagligt.",
      "Undvika all aktivitet som kan skada nätverket eller andra användare.",
      "Acceptera att åtkomst kan övervakas för säkerhets- och efterlevnadsändamål."
    ],
    
    // Privacy Notice
    privacyNotice: "Integritetspolicy",
    dataCollection: "Vi samlar in och behandlar följande data:",
    dataPoints: [
      "Enhetens MAC-adress",
      "Anslutningstidsstämplar",
      "Åtkomstpunktens plats",
      "Webbläsare och enhetstyp"
    ],
    
    // Purpose
    purposeTitle: "Syfte med datainsamling:",
    purposePoints: [
      "Nätverkssäkerhet och bedrägeriförebyggande",
      "Juridisk efterlevnad",
      "Användningsstatistik och tjänstförbättring"
    ],
    
    // Data retention
    dataRetention: "Datalagring: Dina data kommer att lagras i maximalt {months} månader och sedan raderas säkert.",
    
    // User rights
    userRights: "Dina rättigheter:",
    rightsPoints: [
      "Åtkomst, korrigering, radering av dina data",
      "Återkallelse av samtycke när som helst",
      "Kontakta vår Dataskyddsombud: {email}"
    ],
    
    // Consent
    consentTitle: "Samtycke",
    consentText: "Vänligen bekräfta din acceptans för att fortsätta:",
    consentCheckbox: "Jag har läst och accepterar Användarvillkoren och Integritetspolicyn. Jag samtycker till behandlingen av mina personuppgifter enligt beskrivningen ovan.",
    
    // Signature
    signatureTitle: "Digital Signatur",
    signaturePlaceholder: "Skriv ditt fullständiga namn här som digital signatur",
    signatureRequired: "Digital signatur krävs för juridisk efterlevnad",
    
    // Buttons
    connectToWifi: "Fortsätt till Sateva Hotspots Wi-Fi",
    language: "Språk",
    decline: "Avvisa",
    
    // Validation
    mustAcceptTerms: "Du måste acceptera villkoren för att fortsätta",
    mustProvideSignature: "Digital signatur krävs",
    
    // Footer
    poweredBy: "Drivs av GDPR-kompatibelt portalsystem",
    lastUpdated: "Senast uppdaterad: {date}"
  },
  
  da: {
    // Header
    wifiPortal: "Wi-Fi Adgangsportal",
    gdprCompliance: "GDPR-overholdelse Påkrævet",
    
    // Welcome section
    welcome: "Velkommen til {organization}s Wi-Fi",
    complianceRequired: "For at bruge denne Wi-Fi-tjeneste skal du læse og acceptere vores Vilkår for Brug og Fortrolighedspolitik i overensstemmelse med Den Generelle Databeskyttelsesforordning (GDPR).",
    
    // Terms of Use
    termsOfUse: "Brugsvilkår",
    termsContent: "Ved at få adgang til dette Wi-Fi-netværk accepterer du at:",
    termsPoints: [
      "Bruge tjenesten ansvarligt og lovligt.",
      "Undgå enhver aktivitet, der kan skade netværket eller andre brugere.",
      "Acceptere at adgang kan overvåges af sikkerheds- og overholdelsesårsager."
    ],
    
    // Privacy Notice
    privacyNotice: "Fortrolighedspolitik",
    dataCollection: "Vi indsamler og behandler følgende data:",
    dataPoints: [
      "Enhedens MAC-adresse",
      "Forbindelsestidsstempler",
      "Adgangspunktets placering",
      "Browser- og enhedstype"
    ],
    
    // Purpose
    purposeTitle: "Formål med dataindsamling:",
    purposePoints: [
      "Netværkssikkerhed og svindelforebyggelse",
      "Juridisk overholdelse",
      "Brugsstatistikker og tjenesteforbedring"
    ],
    
    // Data retention
    dataRetention: "Dataopbevaring: Dine data vil blive opbevaret i maksimalt {months} måneder og derefter sikkert slettet.",
    
    // User rights
    userRights: "Dine rettigheder:",
    rightsPoints: [
      "Adgang, rettelse, sletning af dine data",
      "Tilbagetrækning af samtykke når som helst",
      "Kontakt vores Databeskyttelsesrådgiver: {email}"
    ],
    
    // Consent
    consentTitle: "Samtykke",
    consentText: "Bekræft venligst din accept for at fortsætte:",
    consentCheckbox: "Jeg har læst og accepterer Brugsvilkårene og Fortrolighedspolitikken. Jeg giver samtykke til behandling af mine personlige data som beskrevet ovenfor.",
    
    // Signature
    signatureTitle: "Digital Signatur",
    signaturePlaceholder: "Skriv dit fulde navn her som digital signatur",
    signatureRequired: "Digital signatur er påkrævet for juridisk overholdelse",
    
    // Buttons
    connectToWifi: "Fortsæt til Sateva Hotspots Wi-Fi",
    language: "Sprog",
    decline: "Afvis",
    
    // Validation
    mustAcceptTerms: "Du skal acceptere vilkårene og betingelserne for at fortsætte",
    mustProvideSignature: "Digital signatur er påkrævet",
    
    // Footer
    poweredBy: "Drevet af GDPR-kompatibelt portalsystem",
    lastUpdated: "Sidst opdateret: {date}"
  },
  
  no: {
    // Header
    wifiPortal: "Wi-Fi Tilgangsportal",
    gdprCompliance: "GDPR-samsvar Påkrevd",
    
    // Welcome section
    welcome: "Velkommen til {organization}s Wi-Fi",
    complianceRequired: "For å bruke denne Wi-Fi-tjenesten må du lese og godta våre Bruksvilkår og Personvernpolicy i samsvar med Personvernforordningen (GDPR).",
    
    // Terms of Use
    termsOfUse: "Bruksvilkår",
    termsContent: "Ved å få tilgang til dette Wi-Fi-nettverket godtar du å:",
    termsPoints: [
      "Bruke tjenesten ansvarlig og lovlig.",
      "Unngå enhver aktivitet som kan skade nettverket eller andre brukere.",
      "Akseptere at tilgang kan overvåkes av sikkerhets- og samsvarsårsaker."
    ],
    
    // Privacy Notice
    privacyNotice: "Personvernerklæring",
    dataCollection: "Vi samler inn og behandler følgende data:",
    dataPoints: [
      "Enhetens MAC-adresse",
      "Tilkoblings-tidsstempler",
      "Tilgangspunktets plassering",
      "Nettleser- og enhetstype"
    ],
    
    // Purpose
    purposeTitle: "Formål med datainnsamling:",
    purposePoints: [
      "Nettverkssikkerhet og svindelforebygging",
      "Juridisk samsvar",
      "Bruksstatistikk og tjenesteforbedring"
    ],
    
    // Data retention
    dataRetention: "Datalagring: Dataene dine vil bli lagret i maksimalt {months} måneder og deretter sikkert slettet.",
    
    // User rights
    userRights: "Dine rettigheter:",
    rightsPoints: [
      "Tilgang, korrigering, sletting av dine data",
      "Tilbaketrekking av samtykke når som helst",
      "Kontakt vår Personvernombud: {email}"
    ],
    
    // Consent
    consentTitle: "Samtykke",
    consentText: "Bekreft din godkjenning for å fortsette:",
    consentCheckbox: "Jeg har lest og godtar Bruksvilkårene og Personvernpolicyen. Jeg samtykker til behandling av mine personopplysninger som beskrevet ovenfor.",
    
    // Signature
    signatureTitle: "Digital Signatur",
    signaturePlaceholder: "Skriv ditt fulle navn her som digital signatur",
    signatureRequired: "Digital signatur er påkrevd for juridisk samsvar",
    
    // Buttons
    connectToWifi: "Fortsett til Sateva Hotspots Wi-Fi",
    language: "Språk",
    decline: "Avvis",
    
    // Validation
    mustAcceptTerms: "Du må godta vilkårene og betingelsene for å fortsette",
    mustProvideSignature: "Digital signatur er påkrevd",
    
    // Footer
    poweredBy: "Drevet av GDPR-kompatibelt portalsystem",
    lastUpdated: "Sist oppdatert: {date}"
  },
  
  fi: {
    // Header
    wifiPortal: "Wi-Fi Käyttöportaali",
    gdprCompliance: "GDPR-vaatimustenmukaisuus Vaaditaan",
    
    // Welcome section
    welcome: "Tervetuloa {organization}n Wi-Fi-yhteyteen",
    complianceRequired: "Käyttääksesi tätä Wi-Fi-palvelua sinun tulee lukea ja hyväksyä käyttöehtomme ja tietosuojakäytäntömme yleisen tietosuoja-asetuksen (GDPR) mukaisesti.",
    
    // Terms of Use
    termsOfUse: "Käyttöehdot",
    termsContent: "Käyttämällä tätä Wi-Fi-verkkoa hyväksyt:",
    termsPoints: [
      "Käyttää palvelua vastuullisesti ja laillisesti.",
      "Välttää kaikkea toimintaa, joka voisi vahingoittaa verkkoa tai muita käyttäjiä.",
      "Hyväksyä että käyttöä voidaan valvoa turvallisuus- ja vaatimustenmukaisuussyistä."
    ],
    
    // Privacy Notice
    privacyNotice: "Tietosuojaseloste",
    dataCollection: "Keräämme ja käsittelemme seuraavia tietoja:",
    dataPoints: [
      "Laitteen MAC-osoite",
      "Yhteyden aikaleima",
      "Tukiaseman sijainti",
      "Selain- ja laitetyyppi"
    ],
    
    // Purpose
    purposeTitle: "Tiedonkeruun tarkoitus:",
    purposePoints: [
      "Verkon turvallisuus ja petosten ehkäisy",
      "Lakisääteinen vaatimustenmukaisuus",
      "Käyttötilastot ja palvelun parantaminen"
    ],
    
    // Data retention
    dataRetention: "Tietojen säilyttäminen: Tietojasi säilytetään enintään {months} kuukautta, jonka jälkeen ne poistetaan turvallisesti.",
    
    // User rights
    userRights: "Oikeutesi:",
    rightsPoints: [
      "Pääsy, korjaus, poisto tietoihisi",
      "Suostumuksen peruuttaminen milloin tahansa",
      "Ota yhteyttä tietosuojavastaavaamme: {email}"
    ],
    
    // Consent
    consentTitle: "Suostumus",
    consentText: "Vahvista hyväksyntäsi jatkaaksesi:",
    consentCheckbox: "Olen lukenut ja hyväksyn käyttöehdot ja tietosuojakäytännön. Annan suostumukseni henkilötietojeni käsittelyyn yllä kuvatulla tavalla.",
    
    // Signature
    signatureTitle: "Digitaalinen Allekirjoitus",
    signaturePlaceholder: "Kirjoita koko nimesi tähän digitaalisena allekirjoituksena",
    signatureRequired: "Digitaalinen allekirjoitus vaaditaan lakisääteistä vaatimustenmukaisuutta varten",
    
    // Buttons
    connectToWifi: "Jatka Sateva Hotspotin Wi-Fi-yhteyteen",
    language: "Kieli",
    decline: "Hylkää",
    
    // Validation
    mustAcceptTerms: "Sinun tulee hyväksyä ehdot jatkaaksesi",
    mustProvideSignature: "Digitaalinen allekirjoitus vaaditaan",
    
    // Footer
    poweredBy: "Toimii GDPR-yhteensopivalla portaalijärjestelmällä",
    lastUpdated: "Viimeksi päivitetty: {date}"
  },
  
  pl: {
    // Header
    wifiPortal: "Portal Dostępu Wi-Fi",
    gdprCompliance: "Zgodność z RODO Wymagana",
    
    // Welcome section
    welcome: "Witamy w Wi-Fi {organization}",
    complianceRequired: "Aby korzystać z tej usługi Wi-Fi, musisz przeczytać i zaakceptować nasze Warunki Użytkowania i Politykę Prywatności zgodnie z Ogólnym Rozporządzeniem o Ochronie Danych (RODO).",
    
    // Terms of Use
    termsOfUse: "Warunki Użytkowania",
    termsContent: "Uzyskując dostęp do tej sieci Wi-Fi, zgadzasz się:",
    termsPoints: [
      "Używać usługi odpowiedzialnie i zgodnie z prawem.",
      "Unikać jakichkolwiek działań, które mogą zaszkodzić sieci lub innym użytkownikom.",
      "Zaakceptować, że dostęp może być monitorowany ze względów bezpieczeństwa i zgodności."
    ],
    
    // Privacy Notice
    privacyNotice: "Informacje o Prywatności",
    dataCollection: "Zbieramy i przetwarzamy następujące dane:",
    dataPoints: [
      "Adres MAC urządzenia",
      "Znaczniki czasu połączenia",
      "Lokalizacja punktu dostępu",
      "Typ przeglądarki i urządzenia"
    ],
    
    // Purpose
    purposeTitle: "Cel zbierania danych:",
    purposePoints: [
      "Bezpieczeństwo sieci i zapobieganie oszustwom",
      "Zgodność prawna",
      "Statystyki użytkowania i poprawa usług"
    ],
    
    // Data retention
    dataRetention: "Przechowywanie danych: Twoje dane będą przechowywane przez maksymalnie {months} miesięcy, a następnie bezpiecznie usunięte.",
    
    // User rights
    userRights: "Twoje prawa:",
    rightsPoints: [
      "Dostęp, korekta, usunięcie Twoich danych",
      "Wycofanie zgody w dowolnym momencie",
      "Skontaktuj się z naszym Inspektorem Ochrony Danych: {email}"
    ],
    
    // Consent
    consentTitle: "Zgoda",
    consentText: "Potwierdź swoją akceptację, aby kontynuować:",
    consentCheckbox: "Przeczytałem i akceptuję Warunki Użytkowania i Politykę Prywatności. Wyrażam zgodę na przetwarzanie moich danych osobowych zgodnie z powyższym opisem.",
    
    // Signature
    signatureTitle: "Podpis Cyfrowy",
    signaturePlaceholder: "Wpisz tutaj swoje pełne imię i nazwisko jako podpis cyfrowy",
    signatureRequired: "Podpis cyfrowy jest wymagany dla zgodności prawnej",
    
    // Buttons
    connectToWifi: "Przejdź do Wi-Fi Sateva Hotspot",
    language: "Język",
    decline: "Odrzuć",
    
    // Validation
    mustAcceptTerms: "Musisz zaakceptować warunki, aby kontynuować",
    mustProvideSignature: "Podpis cyfrowy jest wymagany",
    
    // Footer
    poweredBy: "Zasilany przez system portalu zgodny z RODO",
    lastUpdated: "Ostatnia aktualizacja: {date}"
  },
  
  cs: {
    // Header
    wifiPortal: "Wi-Fi Přístupový Portál",
    gdprCompliance: "Soulad s GDPR Vyžadován",
    
    // Welcome section
    welcome: "Vítejte na Wi-Fi {organization}",
    complianceRequired: "Pro používání této Wi-Fi služby musíte přečíst a přijmout naše Podmínky Používání a Zásady Ochrany Soukromí v souladu s Obecným Nařízením o Ochraně Údajů (GDPR).",
    
    // Terms of Use
    termsOfUse: "Podmínky Používání",
    termsContent: "Přístupem k této Wi-Fi síti souhlasíte s:",
    termsPoints: [
      "Používat službu odpovědně a zákonně.",
      "Vyhýbat se jakékoli aktivitě, která by mohla poškodit síť nebo jiné uživatele.",
      "Přijmout, že přístup může být monitorován z bezpečnostních důvodů a důvodů dodržování předpisů."
    ],
    
    // Privacy Notice
    privacyNotice: "Zásady Ochrany Soukromí",
    dataCollection: "Shromažďujeme a zpracováváme následující údaje:",
    dataPoints: [
      "MAC adresa zařízení",
      "Časová razítka připojení",
      "Umístění přístupového bodu",
      "Typ prohlížeče a zařízení"
    ],
    
    // Purpose
    purposeTitle: "Účel shromažďování údajů:",
    purposePoints: [
      "Zabezpečení sítě a prevence podvodů",
      "Právní soulad",
      "Statistiky používání a zlepšování služeb"
    ],
    
    // Data retention
    dataRetention: "Uchovávání údajů: Vaše údaje budou uloženy maximálně {months} měsíců a poté bezpečně smazány.",
    
    // User rights
    userRights: "Vaše práva:",
    rightsPoints: [
      "Přístup, oprava, vymazání vašich údajů",
      "Odvolání souhlasu kdykoli",
      "Kontaktujte našeho Pověřence pro Ochranu Údajů: {email}"
    ],
    
    // Consent
    consentTitle: "Souhlas",
    consentText: "Potvrďte prosím svůj souhlas pro pokračování:",
    consentCheckbox: "Přečetl jsem a přijímám Podmínky Používání a Zásady Ochrany Soukromí. Souhlasím se zpracováním mých osobních údajů jak je popsáno výše.",
    
    // Signature
    signatureTitle: "Digitální Podpis",
    signaturePlaceholder: "Napište zde své celé jméno jako digitální podpis",
    signatureRequired: "Digitální podpis je vyžadován pro právní soulad",
    
    // Buttons
    connectToWifi: "Pokračovat na Wi-Fi Sateva Hotspot",
    language: "Jazyk",
    decline: "Odmítnout",
    
    // Validation
    mustAcceptTerms: "Musíte přijmout podmínky pro pokračování",
    mustProvideSignature: "Digitální podpis je vyžadován",
    
    // Footer
    poweredBy: "Poháněno systémem portálu kompatibilním s GDPR",
    lastUpdated: "Poslední aktualizace: {date}"
  },
  
  hu: {
    // Header
    wifiPortal: "Wi-Fi Hozzáférési Portál",
    gdprCompliance: "GDPR Megfelelőség Szükséges",
    
    // Welcome section
    welcome: "Üdvözöljük a {organization} Wi-Fi-jén",
    complianceRequired: "A Wi-Fi szolgáltatás használatához el kell olvasnia és el kell fogadnia Felhasználási Feltételeinket és Adatvédelmi Irányelveinket az Általános Adatvédelmi Rendelet (GDPR) szerint.",
    
    // Terms of Use
    termsOfUse: "Felhasználási Feltételek",
    termsContent: "A Wi-Fi hálózat elérésével elfogadja, hogy:",
    termsPoints: [
      "A szolgáltatást felelősségteljesen és törvényesen használja.",
      "Kerül minden olyan tevékenységet, amely károsíthatja a hálózatot vagy más felhasználókat.",
      "Elfogadja, hogy a hozzáférés biztonsági és megfelelőségi okokból figyelemmel kísérhető."
    ],
    
    // Privacy Notice
    privacyNotice: "Adatvédelmi Tájékoztató",
    dataCollection: "Az alábbi adatokat gyűjtjük és dolgozzuk fel:",
    dataPoints: [
      "Eszköz MAC címe",
      "Kapcsolódási időbélyegek",
      "Hozzáférési pont helye",
      "Böngésző és eszköz típusa"
    ],
    
    // Purpose
    purposeTitle: "Az adatgyűjtés célja:",
    purposePoints: [
      "Hálózatbiztonság és csalás megelőzése",
      "Jogi megfelelőség",
      "Használati statisztikák és szolgáltatás fejlesztése"
    ],
    
    // Data retention
    dataRetention: "Adatmegőrzés: Adatait legfeljebb {months} hónapig tároljuk, majd biztonságosan töröljük.",
    
    // User rights
    userRights: "Az Ön jogai:",
    rightsPoints: [
      "Hozzáférés, javítás, törlés az adataihoz",
      "Hozzájárulás visszavonása bármikor",
      "Lépjen kapcsolatba Adatvédelmi Tisztviselőnkkel: {email}"
    ],
    
    // Consent
    consentTitle: "Hozzájárulás",
    consentText: "Kérjük, erősítse meg elfogadását a folytatáshoz:",
    consentCheckbox: "Elolvastam és elfogadom a Felhasználási Feltételeket és az Adatvédelmi Irányelvet. Hozzájárulok személyes adataim fent leírt módon történő feldolgozásához.",
    
    // Signature
    signatureTitle: "Digitális Aláírás",
    signaturePlaceholder: "Írja ide teljes nevét digitális aláírásként",
    signatureRequired: "Digitális aláírás szükséges a jogi megfelelőséghez",
    
    // Buttons
    connectToWifi: "Folytatás a Sateva Hotspot Wi-Fi-jéhez",
    language: "Nyelv",
    decline: "Elutasítás",
    
    // Validation
    mustAcceptTerms: "El kell fogadnia a feltételeket a folytatáshoz",
    mustProvideSignature: "Digitális aláírás szükséges",
    
    // Footer
    poweredBy: "GDPR-kompatibilis portálrendszer által működtetve",
    lastUpdated: "Utolsó frissítés: {date}"
  },
  
  ro: {
    // Header
    wifiPortal: "Portal de Acces Wi-Fi",
    gdprCompliance: "Conformitate GDPR Necesară",
    
    // Welcome section
    welcome: "Bun venit la Wi-Fi-ul {organization}",
    complianceRequired: "Pentru a utiliza acest serviciu Wi-Fi, trebuie să citiți și să acceptați Termenii și Condițiile de Utilizare și Politica de Confidențialitate în conformitate cu Regulamentul General privind Protecția Datelor (GDPR).",
    
    // Terms of Use
    termsOfUse: "Termeni și Condiții",
    termsContent: "Prin accesarea acestei rețele Wi-Fi, acceptați să:",
    termsPoints: [
      "Utilizați serviciul în mod responsabil și legal.",
      "Evitați orice activitate care ar putea dăuna rețelei sau altor utilizatori.",
      "Acceptați că accesul poate fi monitorizat din motive de securitate și conformitate."
    ],
    
    // Privacy Notice
    privacyNotice: "Politica de Confidențialitate",
    dataCollection: "Colectăm și procesăm următoarele date:",
    dataPoints: [
      "Adresa MAC a dispozitivului",
      "Marcaje temporale de conectare",
      "Locația punctului de acces",
      "Tipul de browser și dispozitiv"
    ],
    
    // Purpose
    purposeTitle: "Scopul colectării datelor:",
    purposePoints: [
      "Securitatea rețelei și prevenirea fraudei",
      "Conformitatea legală",
      "Statistici de utilizare și îmbunătățirea serviciilor"
    ],
    
    // Data retention
    dataRetention: "Păstrarea datelor: Datele dumneavoastră vor fi stocate pentru maximum {months} luni și apoi șterse în siguranță.",
    
    // User rights
    userRights: "Drepturile dumneavoastră:",
    rightsPoints: [
      "Accesul, corectarea, ștergerea datelor dumneavoastră",
      "Retragerea consimțământului oricând",
      "Contactați Responsabilul cu Protecția Datelor: {email}"
    ],
    
    // Consent
    consentTitle: "Consimțământ",
    consentText: "Vă rugăm să confirmați acceptarea pentru a continua:",
    consentCheckbox: "Am citit și accept Termenii și Condițiile și Politica de Confidențialitate. Îmi dau consimțământul pentru procesarea datelor mele personale așa cum este descris mai sus.",
    
    // Signature
    signatureTitle: "Semnătură Digitală",
    signaturePlaceholder: "Scrieți numele complet aici ca semnătură digitală",
    signatureRequired: "Semnătura digitală este necesară pentru conformitatea legală",
    
    // Buttons
    connectToWifi: "Continuați la Wi-Fi-ul Sateva Hotspot",
    language: "Limba",
    decline: "Refuzați",
    
    // Validation
    mustAcceptTerms: "Trebuie să acceptați termenii și condițiile pentru a continua",
    mustProvideSignature: "Semnătura digitală este necesară",
    
    // Footer
    poweredBy: "Alimentat de sistemul portal compatibil GDPR",
    lastUpdated: "Ultima actualizare: {date}"
  },
  
  bg: {
    // Header
    wifiPortal: "Wi-Fi Портал за Достъп",
    gdprCompliance: "Изисква се Съответствие с GDPR",
    
    // Welcome section
    welcome: "Добре дошли в Wi-Fi на {organization}",
    complianceRequired: "За да използвате тази Wi-Fi услуга, трябва да прочетете и приемете нашите Условия за Използване и Политика за Поверителност в съответствие с Общия Регламент за Защита на Данните (GDPR).",
    
    // Terms of Use
    termsOfUse: "Условия за Използване",
    termsContent: "Чрез достъпа до тази Wi-Fi мрежа, вие се съгласявате да:",
    termsPoints: [
      "Използвате услугата отговорно и законно.",
      "Избягвате всякаква дейност, която може да навреди на мрежата или други потребители.",
      "Приемете, че достъпът може да бъде наблюдаван по причини за сигурност и съответствие."
    ],
    
    // Privacy Notice
    privacyNotice: "Политика за Поверителност",
    dataCollection: "Събираме и обработваме следните данни:",
    dataPoints: [
      "MAC адрес на устройството",
      "Времеви печати на свързване",
      "Местоположение на точката за достъп",
      "Тип браузър и устройство"
    ],
    
    // Purpose
    purposeTitle: "Цел на събирането на данни:",
    purposePoints: [
      "Мрежова сигурност и предотвратяване на измами",
      "Правно съответствие",
      "Статистики за използване и подобряване на услугите"
    ],
    
    // Data retention
    dataRetention: "Съхранение на данни: Вашите данни ще бъдат съхранявани за максимум {months} месеца и след това безопасно изтрити.",
    
    // User rights
    userRights: "Вашите права:",
    rightsPoints: [
      "Достъп, корекция, изтриване на вашите данни",
      "Оттегляне на съгласието по всяко време",
      "Свържете се с нашия Длъжностно лице по Защита на Данните: {email}"
    ],
    
    // Consent
    consentTitle: "Съгласие",
    consentText: "Моля, потвърдете вашето приемане за да продължите:",
    consentCheckbox: "Прочетох и приемам Условията за Използване и Политиката за Поверителност. Давам съгласие за обработката на моите лични данни както е описано по-горе.",
    
    // Signature
    signatureTitle: "Цифров Подпис",
    signaturePlaceholder: "Напишете пълното си име тук като цифров подпис",
    signatureRequired: "Цифровият подпис е необходим за правно съответствие",
    
    // Buttons
    connectToWifi: "Продължете към Wi-Fi на Sateva Hotspot",
    language: "Език",
    decline: "Отказвам",
    
    // Validation
    mustAcceptTerms: "Трябва да приемете условията за да продължите",
    mustProvideSignature: "Цифровият подпис е необходим",
    
    // Footer
    poweredBy: "Задвижван от система портал съвместима с GDPR",
    lastUpdated: "Последна актуализация: {date}"
  },
  
  ar: {
    // Header
    wifiPortal: "بوابة الوصول إلى الواي فاي",
    gdprCompliance: "الامتثال للائحة حماية البيانات العامة مطلوب",
    
    // Welcome section
    welcome: "مرحباً بك في شبكة الواي فاي الخاصة بـ {organization}",
    complianceRequired: "لاستخدام خدمة الواي فاي هذه، يجب عليك قراءة وقبول شروط الاستخدام وسياسة الخصوصية وفقاً للائحة العامة لحماية البيانات (GDPR).",
    
    // Terms of Use
    termsOfUse: "شروط الاستخدام",
    termsContent: "من خلال الوصول إلى شبكة الواي فاي هذه، فإنك توافق على:",
    termsPoints: [
      "استخدام الخدمة بمسؤولية وقانونية.",
      "تجنب أي نشاط قد يضر بالشبكة أو المستخدمين الآخرين.",
      "قبول أن الوصول قد يخضع للمراقبة لأغراض الأمان والامتثال."
    ],
    
    // Privacy Notice
    privacyNotice: "إشعار الخصوصية",
    dataCollection: "نحن نجمع ونعالج البيانات التالية:",
    dataPoints: [
      "عنوان MAC للجهاز",
      "طوابع وقت الاتصال",
      "موقع نقطة الوصول",
      "نوع المتصفح والجهاز"
    ],
    
    // Purpose
    purposeTitle: "الغرض من جمع البيانات:",
    purposePoints: [
      "أمان الشبكة ومنع الاحتيال",
      "الامتثال القانوني",
      "إحصائيات الاستخدام وتحسين الخدمة"
    ],
    
    // Data retention
    dataRetention: "الاحتفاظ بالبيانات: سيتم تخزين بياناتك لمدة أقصاها {months} أشهر ثم حذفها بأمان.",
    
    // User rights
    userRights: "حقوقك:",
    rightsPoints: [
      "الوصول والتصحيح وحذف بياناتك",
      "سحب الموافقة في أي وقت",
      "الاتصال بمسؤول حماية البيانات لدينا: {email}"
    ],
    
    // Consent
    consentTitle: "الموافقة",
    consentText: "يرجى تأكيد قبولك للمتابعة:",
    consentCheckbox: "لقد قرأت وأوافق على شروط الاستخدام وسياسة الخصوصية. أوافق على معالجة بياناتي الشخصية كما هو موضح أعلاه.",
    
    // Signature
    signatureTitle: "التوقيع الرقمي",
    signaturePlaceholder: "اكتب اسمك الكامل هنا كتوقيع رقمي",
    signatureRequired: "التوقيع الرقمي مطلوب للامتثال القانوني",
    
    // Buttons
    connectToWifi: "متابعة إلى شبكة واي فاي ساتيفا هوت سبوت",
    language: "اللغة",
    decline: "رفض",
    
    // Validation
    mustAcceptTerms: "يجب عليك قبول الشروط والأحكام للمتابعة",
    mustProvideSignature: "التوقيع الرقمي مطلوب",
    
    // Footer
    poweredBy: "مشغل بواسطة نظام بوابة متوافق مع لائحة حماية البيانات العامة",
    lastUpdated: "آخر تحديث: {date}"
  },
  
  zh: {
    // Header
    wifiPortal: "Wi-Fi 接入门户",
    gdprCompliance: "需要 GDPR 合规性",
    
    // Welcome section
    welcome: "欢迎使用 {organization} 的 Wi-Fi",
    complianceRequired: "要使用此 Wi-Fi 服务，您必须根据《通用数据保护条例》(GDPR) 阅读并接受我们的使用条款和隐私政策。",
    
    // Terms of Use
    termsOfUse: "使用条款",
    termsContent: "通过访问此 Wi-Fi 网络，您同意:",
    termsPoints: [
      "负责任且合法地使用服务。",
      "避免任何可能损害网络或其他用户的活动。",
      "接受出于安全和合规目的可能监控访问。"
    ],
    
    // Privacy Notice
    privacyNotice: "隐私声明",
    dataCollection: "我们收集并处理以下数据:",
    dataPoints: [
      "设备 MAC 地址",
      "连接时间戳",
      "接入点位置",
      "浏览器和设备类型"
    ],
    
    // Purpose
    purposeTitle: "数据收集目的:",
    purposePoints: [
      "网络安全和欺诈防范",
      "法律合规",
      "使用统计和服务改进"
    ],
    
    // Data retention
    dataRetention: "数据保留：您的数据将最多存储 {months} 个月，然后安全删除。",
    
    // User rights
    userRights: "您的权利:",
    rightsPoints: [
      "访问、更正、删除您的数据",
      "随时撤回同意",
      "联系我们的数据保护官: {email}"
    ],
    
    // Consent
    consentTitle: "同意",
    consentText: "请确认您的接受以继续:",
    consentCheckbox: "我已阅读并接受使用条款和隐私政策。我同意按上述描述处理我的个人数据。",
    
    // Signature
    signatureTitle: "数字签名",
    signaturePlaceholder: "在此输入您的全名作为数字签名",
    signatureRequired: "法律合规需要数字签名",
    
    // Buttons
    connectToWifi: "继续使用 Sateva Hotspot 的 Wi-Fi",
    language: "语言",
    decline: "拒绝",
    
    // Validation
    mustAcceptTerms: "您必须接受条款和条件才能继续",
    mustProvideSignature: "需要数字签名",
    
    // Footer
    poweredBy: "由符合 GDPR 的门户系统提供支持",
    lastUpdated: "最后更新: {date}"
  },
  
  ja: {
    // Header
    wifiPortal: "Wi-Fi アクセスポータル",
    gdprCompliance: "GDPR コンプライアンスが必要",
    
    // Welcome section
    welcome: "{organization} の Wi-Fi へようこそ",
    complianceRequired: "この Wi-Fi サービスを利用するには、一般データ保護規則（GDPR）に従って利用規約とプライバシーポリシーをお読みいただき、同意していただく必要があります。",
    
    // Terms of Use
    termsOfUse: "利用規約",
    termsContent: "この Wi-Fi ネットワークにアクセスすることで、以下に同意したものとみなされます:",
    termsPoints: [
      "サービスを責任を持って合法的に使用すること。",
      "ネットワークや他のユーザーに害を与える可能性のある活動を避けること。",
      "セキュリティとコンプライアンスの目的でアクセスが監視される可能性があることを受け入れること。"
    ],
    
    // Privacy Notice
    privacyNotice: "プライバシー通知",
    dataCollection: "以下のデータを収集・処理します:",
    dataPoints: [
      "デバイスの MAC アドレス",
      "接続のタイムスタンプ",
      "アクセスポイントの場所",
      "ブラウザとデバイスの種類"
    ],
    
    // Purpose
    purposeTitle: "データ収集の目的:",
    purposePoints: [
      "ネットワークセキュリティと詐欺防止",
      "法的コンプライアンス",
      "使用統計とサービス改善"
    ],
    
    // Data retention
    dataRetention: "データ保持：お客様のデータは最大 {months} ヶ月間保存され、その後安全に削除されます。",
    
    // User rights
    userRights: "お客様の権利:",
    rightsPoints: [
      "データへのアクセス、修正、削除",
      "いつでも同意を撤回する権利",
      "データ保護責任者への連絡: {email}"
    ],
    
    // Consent
    consentTitle: "同意",
    consentText: "続行するには同意をご確認ください:",
    consentCheckbox: "利用規約とプライバシーポリシーを読み、同意します。上記の説明に従って個人データの処理に同意します。",
    
    // Signature
    signatureTitle: "デジタル署名",
    signaturePlaceholder: "デジタル署名として氏名をフルネームで入力してください",
    signatureRequired: "法的コンプライアンスのためデジタル署名が必要です",
    
    // Buttons
    connectToWifi: "Sateva Hotspot の Wi-Fi に続行",
    language: "言語",
    decline: "拒否",
    
    // Validation
    mustAcceptTerms: "続行するには利用規約に同意する必要があります",
    mustProvideSignature: "デジタル署名が必要です",
    
    // Footer
    poweredBy: "GDPR 準拠ポータルシステムによる運営",
    lastUpdated: "最終更新: {date}"
  },
  
  ko: {
    // Header
    wifiPortal: "Wi-Fi 액세스 포털",
    gdprCompliance: "GDPR 준수 필요",
    
    // Welcome section
    welcome: "{organization}의 Wi-Fi에 오신 것을 환영합니다",
    complianceRequired: "이 Wi-Fi 서비스를 이용하려면 일반 데이터 보호 규정(GDPR)에 따라 이용 약관 및 개인정보 처리방침을 읽고 동의해야 합니다.",
    
    // Terms of Use
    termsOfUse: "이용 약관",
    termsContent: "이 Wi-Fi 네트워크에 접속함으로써 다음에 동의합니다:",
    termsPoints: [
      "서비스를 책임감 있고 합법적으로 사용할 것.",
      "네트워크나 다른 사용자에게 해를 끼칠 수 있는 활동을 피할 것.",
      "보안 및 규정 준수 목적으로 접속이 모니터링될 수 있음을 받아들일 것."
    ],
    
    // Privacy Notice
    privacyNotice: "개인정보 처리방침",
    dataCollection: "다음 데이터를 수집하고 처리합니다:",
    dataPoints: [
      "기기 MAC 주소",
      "연결 타임스탬프",
      "액세스 포인트 위치",
      "브라우저 및 기기 유형"
    ],
    
    // Purpose
    purposeTitle: "데이터 수집 목적:",
    purposePoints: [
      "네트워크 보안 및 사기 방지",
      "법적 준수",
      "사용 통계 및 서비스 개선"
    ],
    
    // Data retention
    dataRetention: "데이터 보관: 귀하의 데이터는 최대 {months}개월간 저장된 후 안전하게 삭제됩니다.",
    
    // User rights
    userRights: "귀하의 권리:",
    rightsPoints: [
      "데이터 접근, 수정, 삭제",
      "언제든지 동의 철회",
      "데이터 보호 담당자 연락: {email}"
    ],
    
    // Consent
    consentTitle: "동의",
    consentText: "계속하려면 동의를 확인해 주세요:",
    consentCheckbox: "이용 약관 및 개인정보 처리방침을 읽고 동의합니다. 위에서 설명한 대로 개인 데이터 처리에 동의합니다.",
    
    // Signature
    signatureTitle: "디지털 서명",
    signaturePlaceholder: "디지털 서명으로 성명을 입력해 주세요",
    signatureRequired: "법적 준수를 위해 디지털 서명이 필요합니다",
    
    // Buttons
    connectToWifi: "Sateva Hotspot Wi-Fi로 계속",
    language: "언어",
    decline: "거부",
    
    // Validation
    mustAcceptTerms: "계속하려면 약관에 동의해야 합니다",
    mustProvideSignature: "디지털 서명이 필요합니다",
    
    // Footer
    poweredBy: "GDPR 준수 포털 시스템으로 구동",
    lastUpdated: "마지막 업데이트: {date}"
  }
};

export const getTranslation = (lang, key, variables = {}) => {
  let text = translations[lang]?.[key] || translations.en[key] || key;
  
  // Replace variables in text
  Object.keys(variables).forEach(varKey => {
    text = text.replace(`{${varKey}}`, variables[varKey]);
  });
  
  return text;
};

export const getArrayTranslation = (lang, key) => {
  return translations[lang]?.[key] || translations.en[key] || [];
};
